// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import { AttachmentPastDueShipmentsTable, PastDueShipmentsTable } from './components/past-due-shipments-table';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getPastDueShipments, getShippingLocations
} from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class PastDueShipments extends Component {

    state = {
        shippingLocations: [],
        selectedShippingLocation: '',
        pastDueShipmentsResults: [],
        attachPastDueShipmentsResult: []
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getShippingLocations().then( response => {

            this.setState( {
                shippingLocations: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleShippingLocationChange ( val ) {

        this.setState( {
            selectedShippingLocation: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        if ( this.state.selectedShippingLocation === -1 ) {

            this.setState( {
                pastDueShipmentsResults: [],
                attachPastDueShipmentsResult: []
            } );

        } else {

            this.props.increaseCounter();
            getPastDueShipments( this.state.selectedShippingLocation )
                .then( response => {

                    this.setState( {
                        pastDueShipmentsResults: response.pastDueDates,
                        attachPastDueShipmentsResult: response.attachmentPastDueDates
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            selectedShippingLocation, shippingLocations,
            pastDueShipmentsResults, attachPastDueShipmentsResult
        } = this.state;

        const additionalInfo = { unitName: this.props.unit.name };
        const pastDueShipmentsResultsVal = pastDueShipmentsResults
            .map( i => ( { ...i, ...additionalInfo } ) );

        const attachResultsVal = attachPastDueShipmentsResult
            .map( i => ( { ...i, ...additionalInfo } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Past Due Shipments</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-past-due-shipments-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-past-due-shipments-select"
                                    label="Shipping Location"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleShippingLocationChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={shippingLocations}
                                    placeholder="Select Shipping Location"
                                    selectedValue={selectedShippingLocation}
                                />

                                {selectedShippingLocation && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        {selectedShippingLocation && (
                            <PastDueShipmentsTable
                                results={pastDueShipmentsResultsVal}
                                totalPastDueShipmentsRows={pastDueShipmentsResultsVal.length}
                                totalAttachPastDueShipmentsRows={attachResultsVal.length}
                            />
                        )}
                        {selectedShippingLocation && attachResultsVal.length > 0 && (
                            <AttachmentPastDueShipmentsTable
                                results={attachResultsVal}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

PastDueShipments.displayName = 'PastDueShipments';
PastDueShipments.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( PastDueShipments ) );
